//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext,  useContext, useState, useEffect } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Box,
  Paper,
  TableContainer,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
} from '@mui/material';

// === UTILS ===
import { regex_start_of_word, spaceBeforeWord } from 'components/utils';

import { ReportContext } from '../ReportContext/ReportContext';

//#endregion

//-----------------------------------------------------------------
export function ReportTable() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const theme = useTheme();

  const { 
    report_name,
    report_data,
    is_loading ,
  } = useContext( ReportContext );

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {

    },
    header: {
      padding: '0.5rem',
    },
    loading: {  
      display    : is_loading ? '' : 'none'   ,    
      color      : theme.palette.primary.main ,
      position   : 'absolute' ,
      top        : '50%'      ,
      left       : '50%'      ,
      marginTop  : -12        ,
      marginLeft : -12        ,
    }
  }

  // === ATTRIBUTES ===
  const
    CONTAINER = {
      component: Paper,
    },
    HEADER = {
      sx       : _styles.header  ,
      variant  : 'h5'            ,
      children : [ report_name ] ,
    },
    REPORT = {
      size: 'small',
    },
    REPORT_COLUMNS = {
      children: [ <TableRow>{displayHeaders()}</TableRow> ],
    },
    REPORT_DATA = {
      children: [ displayData() ],
    },
    LOADING = {
      sx   : _styles.loading,
      size : 50,
    };

  //#endregion

  //#region [EFFECT]

  //#endregion

  //#region [EVENTS]

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    if ( report_data.length <= 0 ) return <CircularProgress { ...LOADING } />;

    return (
      <TableContainer { ...CONTAINER } >
        <Typography { ...HEADER } />
        <Table { ...REPORT }>
          <TableHead { ...REPORT_COLUMNS } />
          <TableBody { ...REPORT_DATA    } />
        </Table>        
      </TableContainer>
    );
  }

  //-----------------------------------------------------------------
  function displayHeaders() {
    //-----------------------------------------------------------------
    if ( report_data.length <= 0 ) return null;

    try {
      const header_row      = report_data[0];
      const header_names    = Object.keys( header_row );
      const header_elements = header_names.map( (header, index) => (
        <TableCell className='sticky-header' key={index}>
          {
            header.replace( regex_start_of_word, spaceBeforeWord )
            .split('(')
            .join(' (')
          }
        </TableCell>
      ) );

      return header_elements;
    } catch (error) {
      console.warn( error );
    }

    return <div>Error</div>
  }

  //-----------------------------------------------------------------
  function displayData() {
    //-----------------------------------------------------------------
    if ( report_data.length <= 0 ) return null;

    try {
      const result = [];
  
      report_data.forEach((row, index) => {
        const rowElements = Object.values(row).map((column, index) => <TableCell key={index}>{column}</TableCell>);
        result.push(
          <TableRow key={index} id={index}>
            {rowElements}
          </TableRow>
        );
      });
  
      const result_limited = result.slice(0, 25);
  
      return result_limited;
    } catch (error) {
      console.warn( error );
    }

    return <div>Error</div>
  };

  //#endregion

  return display();
}